<template>
  <div
    class="relative h-full overflow-x-hidden overflow-y-scroll rounded-md bg-white p-6"
  >
    <h4
      class="sticky top-0 bg-white pb-2 text-2xs font-bold uppercase text-body-color"
    >
      Equipment observed but not listed on current scheduled auto policy:
      <span>{{ insight.associated_vehicles.length }}</span>
    </h4>
    <div class="mt-4 flex flex-col gap-4 rounded-md">
      <div
        v-for="(item, index) in nonSAEqiupment"
        :key="`${item.id}-${index}`"
        class="rounded-md border-2 border-orange-500 px-3 py-2"
      >
        <!-- :to="{ name: 'VehicleShow', params: { id: item.id } }" -->
        <a
          :href="`/broker/vehicles/${item.id}`"
          target="_blank"
          class="text-xl text-orange-500 no-underline"
        >
          <div class="flex flex-col items-start gap-3 leading-snug">
            <div>
              <div class="mt-2 flex items-center gap-4 underline">
                {{ item.vin }}
                <div class="flex items-center">
                  <custom-badge
                    bg-color-class="bg-orange-500"
                    color-class="text-white"
                    size="md"
                    text="Potentially Uninsured Vehicle"
                    icon="exclamation"
                  ></custom-badge>
                </div>
              </div>
            </div>
            <div
              class="grid w-full grid-cols-6 grid-rows-2 justify-start gap-x-8 gap-y-2"
            >
              <div class="col-span-1 row-span-2">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">Vehicle Type</div>
                  </h4>
                  <div class="inline-block text-xs text-dark-gray">
                    <div class="flex flex-col items-start justify-start">
                      <div class="h-16">
                        <svg
                          v-if="item?.is_type == 'power_unit'"
                          class="h-full w-full"
                          viewBox="0 0 33 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.1777 10.5831L10.8322 10.7935V10.7935L10.1777 10.5831ZM15.125 9.62891H15.8125V8.94141H15.125V9.62891ZM15.125 19.2539V19.9414H15.8125V19.2539H15.125ZM2.75 19.2539H2.0625V19.9414H2.75V19.2539ZM4.29688 16.5039V17.1914H4.69896L4.89608 16.841L4.29688 16.5039ZM5.4495 14.4548L4.85029 14.1177L5.4495 14.4548ZM9.15848 13.7539V14.4414H9.65964L9.813 13.9643L9.15848 13.7539ZM11.4867 8.94141C10.5908 8.94141 9.7973 9.51981 9.52314 10.3728L10.8322 10.7935C10.9236 10.5092 11.1881 10.3164 11.4867 10.3164V8.94141ZM15.125 8.94141H11.4867V10.3164H15.125V8.94141ZM15.8125 16.5039V9.62891H14.4375V16.5039H15.8125ZM14.4375 16.5039V19.2539H15.8125V16.5039H14.4375ZM15.125 18.5664H2.75V19.9414H15.125V18.5664ZM3.4375 19.2539V17.8789H2.0625V19.2539H3.4375ZM3.4375 17.8789C3.4375 17.4992 3.7453 17.1914 4.125 17.1914V15.8164C2.98591 15.8164 2.0625 16.7398 2.0625 17.8789H3.4375ZM4.125 17.1914H4.29688V15.8164H4.125V17.1914ZM4.85029 14.1177L3.69767 16.1669L4.89608 16.841L6.04871 14.7919L4.85029 14.1177ZM6.64792 13.0664C5.90279 13.0664 5.2156 13.4683 4.85029 14.1177L6.04871 14.7919C6.17048 14.5754 6.39954 14.4414 6.64792 14.4414V13.0664ZM9.15848 13.0664H6.64792V14.4414H9.15848V13.0664ZM9.52314 10.3728L8.50396 13.5435L9.813 13.9643L10.8322 10.7935L9.52314 10.3728Z"
                            fill="currentColor"
                          />
                          <path
                            d="M15.125 19.2539H14.4375V19.9414H15.125V19.2539ZM17.875 19.2539V19.9414H18.5625V19.2539H17.875ZM17.875 8.00391L17.2726 7.67259L17.1875 7.82732V8.00391H17.875ZM18.8632 6.20725L19.4656 6.53856L18.8632 6.20725ZM15.8125 8.00391C15.8125 7.00289 16.624 6.19141 17.625 6.19141V4.81641C15.8646 4.81641 14.4375 6.2435 14.4375 8.00391H15.8125ZM15.8125 19.2539V8.00391H14.4375V19.2539H15.8125ZM17.875 18.5664H15.125V19.9414H17.875V18.5664ZM17.1875 8.00391V19.2539H18.5625V8.00391H17.1875ZM18.2608 5.87593L17.2726 7.67259L18.4774 8.33523L19.4656 6.53856L18.2608 5.87593ZM18.4473 6.19141C18.2854 6.19141 18.1827 6.01781 18.2608 5.87593L19.4656 6.53856C19.8915 5.76407 19.3312 4.81641 18.4473 4.81641V6.19141ZM17.625 6.19141H18.4473V4.81641H17.625V6.19141Z"
                            fill="currentColor"
                          />
                          <circle
                            cx="26.625"
                            cy="22.0039"
                            r="2.75"
                            stroke="currentColor"
                            stroke-width="1.375"
                          />
                          <circle
                            cx="26.625"
                            cy="22.0039"
                            r="1.375"
                            fill="currentColor"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2.0625 18.5664H2.75H30.1053H30.5108L30.707 18.9214L31.4669 20.2964L32.2267 21.6714L32.7904 22.6914H31.625H28.7884C28.8449 22.4717 28.875 22.2413 28.875 22.0039C28.875 21.7665 28.8449 21.5361 28.7884 21.3164H30.4596L30.2634 20.9614L29.6997 19.9414H27.944C27.4592 19.5135 26.8224 19.2539 26.125 19.2539C25.4276 19.2539 24.7908 19.5135 24.306 19.9414H22.444C21.9592 19.5135 21.3224 19.2539 20.625 19.2539C19.9276 19.2539 19.2908 19.5135 18.806 19.9414H8.694C8.20923 19.5135 7.57243 19.2539 6.875 19.2539C6.17757 19.2539 5.54077 19.5135 5.056 19.9414H3.4375V21.3164H4.21164C4.15508 21.5361 4.125 21.7665 4.125 22.0039C4.125 22.2413 4.15508 22.4717 4.21164 22.6914H2.75H2.0625V22.0039V19.2539V18.5664ZM9.625 22.0039C9.625 21.7665 9.59492 21.5361 9.53836 21.3164H17.9616C17.9051 21.5361 17.875 21.7665 17.875 22.0039C17.875 22.2413 17.9051 22.4717 17.9616 22.6914H9.53836C9.59492 22.4717 9.625 22.2413 9.625 22.0039ZM23.375 22.0039C23.375 21.7665 23.3449 21.5361 23.2884 21.3164H23.4616C23.4051 21.5361 23.375 21.7665 23.375 22.0039ZM23.375 22.0039C23.375 22.2413 23.4051 22.4717 23.4616 22.6914H23.2884C23.3449 22.4717 23.375 22.2413 23.375 22.0039Z"
                            fill="currentColor"
                          />
                          <circle
                            cx="20.625"
                            cy="22.0039"
                            r="2.75"
                            stroke="currentColor"
                            stroke-width="1.375"
                          />
                          <circle
                            cx="20.625"
                            cy="22.0039"
                            r="1.375"
                            fill="currentColor"
                          />
                          <circle
                            cx="6.625"
                            cy="22.0039"
                            r="2.75"
                            stroke="currentColor"
                            stroke-width="1.375"
                          />
                          <circle
                            cx="6.625"
                            cy="22.0039"
                            r="1.375"
                            fill="currentColor"
                          />
                          <path
                            d="M11 19.2539H15.125V23.3789C15.125 24.1383 14.5094 24.7539 13.75 24.7539H12.375C11.6156 24.7539 11 24.1383 11 23.3789V19.2539Z"
                            stroke="currentColor"
                            stroke-width="1.375"
                          />
                          <path
                            d="M11 22.0039H15.125"
                            stroke="currentColor"
                            stroke-width="1.375"
                          />
                          <path
                            d="M11.8386 13.0664L12.1136 11.6914H13.0625V13.0664H11.8386Z"
                            fill="#C4C4C4"
                            stroke="currentColor"
                            stroke-width="1.375"
                          />
                          <path
                            d="M4.125 16.5039H6.7127C7.72367 16.5039 8.72076 16.7393 9.625 17.1914V17.1914"
                            stroke="currentColor"
                            stroke-width="1.375"
                          />
                        </svg>
                        <svg
                          v-if="item?.is_type == 'trailer'"
                          class="h-full w-full"
                          viewBox="0 0 33 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="19.3334"
                            cy="22.6706"
                            r="2.66667"
                            stroke="currentColor"
                            stroke-width="1.33333"
                          />
                          <circle
                            cx="19.3335"
                            cy="22.6712"
                            r="1.33333"
                            fill="currentColor"
                          />
                          <circle
                            cx="25.3334"
                            cy="22.6706"
                            r="2.66667"
                            stroke="currentColor"
                            stroke-width="1.33333"
                          />
                          <circle
                            cx="25.3335"
                            cy="22.6712"
                            r="1.33333"
                            fill="currentColor"
                          />
                          <path
                            d="M5.33325 21.3379V24.0046H1.33325"
                            stroke="currentColor"
                            stroke-width="1.33333"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2 7.33789H2.66667H30.6667H31.3333V8.00456V21.3379V22.0046H30.6667H27.916C27.7812 21.4804 27.491 21.0186 27.0974 20.6712H30V8.67122H3.33333V20.6712H18.2361C17.8425 21.0186 17.5522 21.4804 17.4173 22.0046H2.66667H2V21.3379V8.00456V7.33789ZM23.5693 20.6712C23.1757 21.0186 22.8855 21.4804 22.7507 22.0046H22.5826C22.4477 21.4804 22.1574 21.0186 21.7638 20.6712H23.5693Z"
                            fill="currentColor"
                          />
                          <path
                            d="M9.33325 21.3379V23.3379H17.3333"
                            stroke="currentColor"
                            stroke-width="1.33333"
                          />
                        </svg>
                      </div>
                      <div>{{ capitalizeWords(item?.is_type) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-1">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">Make</div>
                  </h4>
                  <div
                    v-if="item?.make"
                    class="text-2xs text-dark-gray"
                  >
                    <div>{{ item?.make }}</div>
                  </div>
                  <div
                    v-else
                    class="text-2xs text-body-color"
                  >
                    <div>-</div>
                  </div>
                </div>
              </div>
              <div class="col-span-1">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">Model</div>
                  </h4>
                  <div
                    v-if="item?.model"
                    class="text-2xs text-dark-gray"
                  >
                    <div>{{ item?.model }}</div>
                  </div>
                  <div
                    v-else
                    class="text-2xs text-body-color"
                  >
                    <div>-</div>
                  </div>
                </div>
              </div>
              <div class="col-span-1">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">Year</div>
                  </h4>
                  <div
                    v-if="item?.model_year"
                    class="text-2xs text-dark-gray"
                    :class="{
                      'text-dark-gray':
                        insight?.is_type ==
                        'equipment_not_listed_on_scheduled_auto',
                      'text-body-color':
                        insight?.is_type !==
                        'equipment_not_listed_on_scheduled_auto',
                    }"
                  >
                    <div>{{ item?.model_year }}</div>
                  </div>
                  <div
                    v-else
                    class="text-2xs text-dark-gray"
                  >
                    <div>-</div>
                  </div>
                </div>
              </div>
              <div class="col-span-2">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">VIN</div>
                  </h4>
                  <div
                    v-if="item?.vin"
                    class="text-2xs text-dark-gray"
                    :class="{
                      'text-dark-gray':
                        insight?.is_type ==
                        'equipment_not_listed_on_scheduled_auto',
                      'text-body-color':
                        insight?.is_type !==
                        'equipment_not_listed_on_scheduled_auto',
                    }"
                  >
                    <div>{{ item?.vin }}</div>
                  </div>
                  <div
                    v-else
                    class="text-2xs text-dark-gray"
                  >
                    <div>-</div>
                  </div>
                </div>
              </div>
              <div class="col-span-1">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">Reg. State</div>
                  </h4>
                  <div
                    v-if="item?.license_plate_state"
                    class="text-2xs text-dark-gray"
                  >
                    <div
                      :style="{
                        'position: relative; top: -1.5px;':
                          insight?.is_type == 'reused_email_address',
                      }"
                    >
                      {{ item?.license_plate_state }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="text-2xs text-dark-gray"
                  >
                    <div>-</div>
                  </div>
                </div>
              </div>
              <div class="col-span-1">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">Plate #</div>
                  </h4>
                  <div
                    v-if="item?.license_plate_number"
                    class="text-2xs text-dark-gray"
                    :class="{
                      'text-dark-gray':
                        insight?.is_type ==
                        'equipment_not_listed_on_scheduled_auto',
                      'text-body-color':
                        insight?.is_type !==
                        'equipment_not_listed_on_scheduled_auto',
                    }"
                  >
                    <div
                      :style="{
                        'position: relative; top: -1.5px;':
                          insight?.is_type ==
                          'equipment_not_listed_on_scheduled_auto',
                      }"
                    >
                      {{ item.license_plate_number }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="text-2xs text-dark-gray"
                  >
                    <div>-</div>
                  </div>
                </div>
              </div>
              <div class="col-span-1">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">Class</div>
                  </h4>
                  <div class="text-2xs text-dark-gray">
                    <div
                      v-if="item.is_type == 'power_unit'"
                      class="flex items-start justify-start gap-x-0.5"
                    >
                      <span>{{ classType(item) }}</span>
                      <info-tooltip
                        v-if="item?.weight_class"
                        color-scheme="orange"
                        size="sm"
                        :content="item?.weight_class"
                      >
                        <div>{{ item?.weight_class }}</div>
                      </info-tooltip>
                    </div>
                    <div
                      v-else-if="item.is_type == 'trailer'"
                      class="flex items-start justify-start"
                    >
                      <!-- {{ item?.display_trailer_type === 'Van' ? 'Dry Van' : item?.display_trailer_type ? item?.display_trailer_type : '-' }} -->
                      <info-tooltip
                        v-if="item.display_trailer_type"
                        color-scheme="orange"
                        size="sm"
                        :title="
                          item?.display_trailer_type === 'Van'
                            ? 'Dry Van'
                            : item?.display_trailer_type
                              ? item?.display_trailer_type
                              : '-'
                        "
                      >
                        <div>
                          {{
                            item?.display_trailer_type === 'Van'
                              ? 'Dry Van'
                              : item?.display_trailer_type
                                ? item?.display_trailer_type
                                : '-'
                          }}
                        </div>
                      </info-tooltip>
                    </div>
                    <div
                      v-else
                      class="text-2xs text-dark-gray"
                    >
                      <div>-</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-2">
                <div class="border-2 border-transparent">
                  <h4
                    class="mb-1 text-2xs font-bold uppercase text-gray-over-dark"
                  >
                    <div class="pt-1">Last seen on</div>
                  </h4>
                  <div class="text-2xs text-dark-gray">
                    <div>
                      {{ item?.last_seen_date ? item?.last_seen_date : '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div v-if="insight.is_type === 'associated_digital_activity'">
      <template
        v-for="(carrier, index) in digitalInsights()"
        :key="index"
      >
        <div
          class="mb-3 flex flex-col items-start gap-3 rounded-md border border-gray-over-dark px-3 py-2"
        >
          <div class="mt-2 flex items-center gap-4">
            <a
              :href="`/broker/carriers/${carrier.id}`"
              target="_blank"
              class="mr-3 text-xl text-yellow-600 underline"
            >
              {{ capitalizeWords(carrier.name) }}
            </a>
            <div class="flex items-center">
              <custom-badge
                :bg-color-class="ratingBgColorClass(carrier.assessment_rating)"
                color-class="text-white"
                size="lg"
                :text="carrier.assessment_rating"
              ></custom-badge>
            </div>
          </div>

          <div class="flex flex-row">
            <div class="mr-10">
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">address</div>
              </h4>
              <h4
                v-if="carrier.physical_addresses"
                class="-mt-1 text-2xs text-body-color"
              >
                {{
                  `${capitalizeWords(
                    carrier.physical_addresses[0]?.street1
                  )}, ${capitalizeWords(
                    carrier.physical_addresses[0]?.city
                  )}, ${capitalizeWords(
                    carrier.physical_addresses[0]?.state
                  )}, ${capitalizeWords(
                    carrier.physical_addresses[0]?.postal_code
                  )}`
                }}
              </h4>
            </div>
            <div>
              <h4 class="mb-1 text-2xs font-bold uppercase text-gray-over-dark">
                <div class="pt-1">authority</div>
              </h4>
              <h4 class="-mt-1 text-2xs text-body-color">
                {{
                  getCommonAuthority(carrier)
                    ? getCommonAuthority(carrier)
                    : '-'
                }}
              </h4>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import InfoTooltip from '@/components/InfoTooltip.vue';

export default {
  name: 'EquipmentNotOnScheduledAuto',
  components: {
    CustomBadge,
    InfoTooltip,
  },
  props: {
    insight: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // associatedCarrierData: {},
      reusedData: {
        phone: '',
        email: '',
        contact: '',
        address: {
          street1: '',
          street2: '',
          city: '',
          state: '',
          postal_code: '',
        },
      },
      matchingVehicles: [],
    };
  },
  computed: {
    associatedItems() {
      switch (this.insight?.is_type) {
        case 'reused_email_address':
          return 'associated_email_addresses';
        case 'reused_phone':
          return 'associated_phones';
        case 'reused_contact':
          return 'associated_contacts';
        case 'reused_address':
          return 'associated_addresses';
        case 'carrier_identifier_changed':
          return 'associated_carriers';
        case 'equipment_not_listed_on_scheduled_auto':
          return 'associated_vehicles';
        default:
          return null;
      }
    },
    associatedCarriers() {
      return this.insight.associated_carriers;
    },

    nonSAEqiupment() {
      let arr = [...this.insight[this.associatedItems]];
      return (
        arr?.sort(
          (objA, objB) =>
            new Date(objB?.last_seen_date) - new Date(objA?.last_seen_date)
        ) || []
      );
    },

    reusedEmailAddresses() {
      var emails = [];
      if (this.insight?.is_type == 'reused_email_address') {
        this.insight.associated_email_addresses.forEach(function (email) {
          emails.push(email.value);
        });
      } else {
        this.allInsights.forEach(function (item) {
          if (item?.is_type == 'reused_email_address') {
            item.associated_email_addresses.forEach(function (email) {
              emails.push(email.value);
            });
          }
        });
      }
      return emails;
    },
    reusedPhones() {
      var phones = [];
      if (this.insight?.is_type == 'reused_phone') {
        this.insight.associated_phones.forEach(function (phone) {
          phones.push(phone.phone_e164);
        });
      } else {
        this.allInsights.forEach(function (item) {
          if (item?.is_type == 'reused_phone') {
            item.associated_phones.forEach(function (phone) {
              phones.push(phone.phone_e164);
            });
          }
        });
      }
      return phones;
    },
    reusedContacts() {
      var contacts = [];
      if (this.insight?.is_type == 'reused_contact') {
        this.insight.associated_contacts.forEach(function (contact) {
          contacts.push(contact.name);
        });
      } else {
        this.allInsights.forEach(function (item) {
          if (item?.is_type == 'reused_contact') {
            item.associated_contacts.forEach(function (contact) {
              contacts.push(contact.name);
            });
          }
        });
      }
      return contacts;
    },
    reusedAddresses() {
      var addresses = [];
      if (this.insight?.is_type == 'reused_address') {
        this.insight.associated_carriers.forEach(function (aCarrier) {
          addresses.push(
            aCarrier.street1 +
              ', ' +
              aCarrier.city +
              ', ' +
              aCarrier.state +
              ' ' +
              aCarrier.postal_code
          );
        });
      } else {
        this.allInsights.forEach(function (item) {
          if (item?.is_type == 'reused_address') {
            item.associated_carriers.forEach(function (aCarrier) {
              addresses.push(
                aCarrier.street1 +
                  ', ' +
                  aCarrier.city +
                  ', ' +
                  aCarrier.state +
                  ' ' +
                  aCarrier.postal_code
              );
            });
          }
        });
      }
      return addresses;
    },
    allInsights() {
      return this.$store.state.carriers.showCarrierInsights?.insights;
    },
    currentCarrier() {
      var object = {
        address: {},
      };
      var self = this;

      // if (this.insight?.is_type == 'reused_phone') {
      //   if (this.reusedPhones.includes(this.$store.state.carriers.showCarrier.dispatch_contact.phone)) {
      //     object.phone = this.$store.state.carriers.showCarrier.dispatch_contact.phone;
      //   } else {
      //     this.$store.state.carriers.showCarrier.contact_information.phones.forEach(function(phone) {
      //       if (self.reusedPhones.includes(phone.value)) {
      //         object.phone = phone.value;
      //       }
      //     });
      //   }
      // } else if (this.$store.state.carriers.showCarrier.dispatch_contact.phone) {
      //   object.phone = this.$store.state.carriers.showCarrier.dispatch_contact.phone;
      // } else {
      //   var censusMainPhone = 0;
      //   this.$store.state.carriers.showCarrier.contact_information.phones.forEach(function(phone) {
      //     if (!censusMainPhone && phone.is_type == 'census_main') {
      //       censusMainPhone = phone.value;
      //       object.phone = phone.value;
      //     }
      //   });
      // }
      // if (this.insight?.is_type == 'reused_email_address') {
      //   if (this.reusedEmailAddresses.includes(this.$store.state.carriers.showCarrier.dispatch_contact.email_address)) {
      //     object.email = this.$store.state.carriers.showCarrier.dispatch_contact.email_address;
      //   } else {
      //     this.$store.state.carriers.showCarrier.contact_information.email_addresses.forEach(function(email) {
      //       if (self.reusedEmailAddresses.includes(email.value)) {
      //         object.email = email.value;
      //       }
      //     });
      //   }
      // } else if (this.$store.state.carriers.showCarrier.dispatch_contact.email_address) {
      //   object.email = this.$store.state.carriers.showCarrier.dispatch_contact.email_address;
      // } else {
      //   var censusMainEmail = '';
      //   this.$store.state.carriers.showCarrier.contact_information.email_addresses.forEach(function(email) {
      //     if (!censusMainEmail && email.is_type == 'census') {
      //       censusMainEmail = email.value;
      //       object.email = email.value;
      //     }
      //   });
      // }
      // if (this.insight?.is_type == 'reused_contact') {
      //   if (this.reusedContacts.includes(this.$store.state.carriers.showCarrier.dispatch_contact.name)) {
      //     object.contact = this.$store.state.carriers.showCarrier.dispatch_contact.name;
      //   } else {

      //   }
      // } else if (this.$store.state.carriers.showCarrier.dispatch_contact.name) {
      //   object.contact = this.$store.state.carriers.showCarrier.dispatch_contact.name;
      // } else {
      //   var censusMainContact = '';
      //   this.$store.state.carriers.showCarrier.contact_information.contacts.forEach(function(contact) {
      //     if (!censusMainContact && contact.is_type == 'census') {
      //       censusMainContact = contact.name;
      //       object.contact = contact.name;
      //     }
      //   });
      // }
      this.$store.state.carriers.showCarrier.contact_information.phones.forEach(
        function (phone) {
          if (self.reusedPhones.includes(phone.phone_e164)) {
            object.phone = phone.value;
            self.reusedData.phone = phone.value;
          }
        }
      );

      this.$store.state.carriers.showCarrier.contact_information.email_addresses.forEach(
        function (email) {
          if (self.reusedEmailAddresses.includes(email.value)) {
            object.email = email.value;
            self.reusedData.email = email.value;
          }
        }
      );

      this.$store.state.carriers.showCarrier.contact_information.contacts.forEach(
        function (contact) {
          if (self.reusedContacts.includes(contact.name)) {
            object.contact = contact.name;
            self.reusedData.contact = contact.name;
          }
        }
      );

      this.$store.state.carriers.showCarrier.contact_information.addresses.forEach(
        function (cAddress) {
          if (
            self.reusedAddresses.includes(
              cAddress?.street1 +
                ', ' +
                cAddress?.city +
                ', ' +
                cAddress?.state +
                ' ' +
                cAddress?.postal_code
            )
          ) {
            console.log('OPTION 1');
            object.address.street1 = cAddress?.street1;
            object.address.street2 = cAddress?.street2;
            object.address.city = cAddress?.city;
            object.address.state = cAddress?.state;
            object.address.postal_code = cAddress?.postal_code;
            self.reusedData.address.street1 = cAddress?.street1;
            self.reusedData.address.street2 = cAddress?.street2;
            self.reusedData.address.city = cAddress?.city;
            self.reusedData.address.state = cAddress?.state;
            self.reusedData.address.postal_code = cAddress?.postal_code;
          } else {
            console.log('OPTION 2');
            object.address.street1 =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.street1;
            object.address.street2 =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.street2;
            object.address.city =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.city;
            object.address.state =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.state;
            object.address.postal_code =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.postal_code;
            self.reusedData.address.street1 =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.street1;
            self.reusedData.address.street2 =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.street2;
            self.reusedData.address.city =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.city;
            self.reusedData.address.state =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.state;
            self.reusedData.address.postal_code =
              self.$store.state.carriers.showCarrier?.contact_information?.headquarters?.address?.postal_code;
          }
        }
      );

      // if (this.insight?.is_type == 'reused_address') {
      //     this.$store.state.carriers.showCarrier.contact_information.addresses.forEach(function(cAddress) {
      //       if (self.reusedAddresses.includes(cAddress?.street1+', '+cAddress?.city+', '+cAddress?.state+' '+cAddress?.postal_code)) {
      //         object.address.street1 = cAddress?.street1;
      //         object.address.street2 = cAddress?.street2;
      //         object.address.city = cAddress?.city;
      //         object.address.state = cAddress?.state;
      //         object.address.postal_code = cAddress?.postal_code;
      //       }
      //     });
      // } else {
      //       object.address.street1 = this.$store.state.carriers.showCarrier?.headquarters?.address?.street1;
      //       object.address.street2 = this.$store.state.carriers.showCarrier?.headquarters?.address?.street2;
      //       object.address.city = this.$store.state.carriers.showCarrier?.headquarters?.address?.city;
      //       object.address.state = this.$store.state.carriers.showCarrier?.headquarters?.address?.state;
      //       object.address.postal_code = this.$store.state.carriers.showCarrier?.headquarters?.address?.postal_code;
      // }

      return object;
    },
  },
  mounted() {
    if (this.insight?.is_type == 'equipment_not_listed_on_scheduled_auto') {
      this.getMatchingVehicles(this.insight.associated_vehicles);
    }
  },
  methods: {
    // getCarrierDataById(cId, cId2) {
    //   var self = this;
    //   var carrierId = cId;
    //   if (carrierId == undefined) {
    //     carrierId = cId2;
    //   }
    //   this.insight.associated_carriers.forEach(function(item) {
    //     // console.log('item = ');

    //     // console.dir(item);
    //     // console.log('item.id = '+item.id);
    //     // console.log('carrierId = '+carrierId);
    //     if (item.id == carrierId) {
    //       self.associatedCarrierData = item;
    //       return item;
    //     }
    //   });

    //   return false;

    // },
    classType: function (vehicle) {
      const weightClass = vehicle?.weight_class;
      switch (true) {
        case weightClass == null:
          return '-';
        case weightClass.includes('Class 1'):
          return 'Class 1';
        case weightClass.includes('Class 2'):
          return 'Class 2';
        case weightClass.includes('Class 3'):
          return 'Class 3';
        case weightClass.includes('Class 4'):
          return 'Class 4';
        case weightClass.includes('Class 5'):
          return 'Class 5';
        case weightClass.includes('Class 6'):
          return 'Class 6';
        case weightClass.includes('Class 7'):
          return 'Class 7';
        case weightClass.includes('Class 8'):
          return 'Class 8';
        default:
          return '-';
      }
    },
    digitalInsights() {
      let insights = [];
      this.allInsights.forEach((insight) => {
        if (insight.is_type === 'associated_digital_activity') {
          insights = insight.associated_carriers;
        }
      });
      return insights;
    },
    getAuthoritiesCurrentCarrier(carrier) {
      if (carrier.broker_authority_status) {
        return 'Broker';
      }
      if (carrier.common_authority_status) {
        return 'Common';
      }
      if (carrier.contract_authority_status) {
        return 'Contract';
      }
    },
    getCommonAuthority(carrier) {
      if (carrier.is_broker_authority) {
        return 'Broker';
      }
      if (carrier.is_common_authority) {
        return 'Common';
      }
      if (carrier.is_contract_authority) {
        return 'Contract';
      }
    },
    getAssociatedCarrierData(key, carrierId) {
      var returned = '';
      this.insight.associated_carriers.forEach(function (item) {
        if (item.id == carrierId) {
          returned = item[key];
          return returned;
        }
      });
      return returned;
    },
    getCarrierId(id1, id2) {
      if (id1 == undefined) {
        return id2;
      }
      return id1;
    },
    getMatchingVehicles(aVehicles) {
      if (this.insight?.is_type === 'associated_digital_activity') {
        const carrier = this.$store.state.carriers?.showCarrier;
        const currentCarrier = [
          {
            rating: carrier?.authority_assessment.rating,
            address: carrier?.contact_information.headquarters.address,
            authority: carrier?.authority.authorities,
          },
        ];
        this.matchingVehicles = currentCarrier;
      } else {
        var plates = [];
        this.$store.state.carriers?.showCarrierEquipment?.rows?.forEach(
          function (vehicle) {
            aVehicles.forEach(function (aVehicle) {
              if (
                vehicle.latest_carrier_vehicle.license_plate_number ==
                aVehicle.license_plate_number
              ) {
                if (vehicle.vin == aVehicle.vin) {
                  plates.push({
                    id: vehicle.id,
                    is_type: vehicle.is_type,
                    vin: vehicle.vin,
                    reg_state:
                      vehicle.latest_carrier_vehicle?.license_plate_state,
                    plate: vehicle.latest_carrier_vehicle.license_plate_number,
                  });
                }
              }
            });
          }
        );
        const seen = new Set();
        var filteredPlates = plates.filter((el) => {
          var reused = seen.has(el.id);
          seen.add(el.id);
          return !reused;
        });
        this.matchingVehicles = filteredPlates;
      }
    },
    ratingBgColorClass: function (rating) {
      switch (rating) {
        case 'Not Authorized':
          return 'bg-red-500';
        case 'Review Required':
          return 'bg-orange-500';
        case 'Acceptable':
          return 'bg-green-500';
        case 'Authorized':
          return 'bg-green-500';
        case 'Authorized Carrier':
          return 'bg-green-500';
        case 'Authorized Broker':
          return 'bg-green-500';
        case 'Authorized Broker/Carrier':
          return 'bg-green-500';
        case 'Unrated':
          return 'bg-body-color';
        default:
          return 'bg-body-color';
      }
    },
    iconColorClass: function (rating) {
      switch (rating) {
        case true:
          return 'text-green-500';
        case false:
          return 'text-red-500';
        default:
          return 'text-body-color';
      }
    },
    wrapClass: function (rating) {
      switch (rating) {
        case true:
          return 'border-green-500';
        case false:
          return 'border-red-500';
        default:
          return 'border-light-gray';
      }
    },
    capitalizeWords: function (str) {
      if (str && typeof str === 'string' && str.length > 0) {
        return str
          .replace('_', ' ')
          .toLowerCase()
          .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
          .replace('Llc', 'LLC')
          .replace('Dba', 'DBA');
      }
    },
    // aggregateStreet1: function() {
    //   var aggregated = [];
    //   this.insight.associated_addresses.forEach(function(el) {
    //     aggregated.push(el.street1);
    //   });
    //   return aggregated;
    // },
    // aggregatedMatch: function(address) {
    //   var match = false;
    //   this.insight.associated_addresses.forEach(function(el) {
    //     if (el.street1 == address.street1) {
    //       match = true;
    //     }
    //   });
    //   return match;
    // },
    isTypeLabel: function () {
      switch (this.insight?.is_type) {
        case 'reused_email_address':
          return 'Email Addresses';
        case 'reused_phone':
          return 'Phone Numbers';
        case 'reused_contact':
          return 'Contacts';
        case 'reused_address':
          return 'Addresses';
        case 'carrier_identifier_changed':
          return 'Carrier ID';
        case 'equipment_not_listed_on_scheduled_auto':
          return 'Equipment - Same License Plate';
        case 'associated_digital_activity':
          return 'Associated carriers';
      }
    },
  },
};
</script>
